import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

let controller = "/MovimentacaoExterno/";

const apiDef = {
  pesquisaSolicitarBaixaMei(data, tokenRecaptcha) {
    return http.post(`${controller}PesquisaSolicitarBaixaMei`, data, tokenRecaptcha);
  },
  solicitarBaixaMei(data) {
    return http.post(`${controller}SolicitarBaixaMei`, data);
  },
  confirmarSenhaSolicitarBaixaMei(data) {
    return http.post(`${controller}confirmarSenhaSolicitarBaixaMei`, data);
  },
  processarSolicitarBaixaMei(data) {
    return http.post(`${controller}processarSolicitarBaixaMei`, data);
  }
};

export default apiDef;
